import React from "react";
import AddProductClothing from "../../components/admin/add/AddProductClothing";

const AddProductCPage = () => {
  return (
    <div className="admin-add-product-page">
      <AddProductClothing />
    </div>
  );
};

export default AddProductCPage;
